<section class="filter-navigation-menu-wrap" id="filterNavigationMenuWrap">
  <div class="item-wrap">
    <!-- <div class="item-option"  (click)="timeFilterValueChange(timeFilterValueEnum.All, pageTypeEnum.Live)" i18n="Sport Tree Title Betting live@@SportTreeTitleLive">Live</div>
    <div class="item-option"  (click)="timeFilterValueChange(timeFilterValueEnum.Today, pageTypeEnum.Soon)" i18n="Sport Tree Title Betting prematch@@SportTreeTitleBetting">Sportsko kladjenje</div> -->
    <!-- <ng-container *ngFor="let day of nextSixDays">
      <div (click)="selectTab()">{{day | date:'EEEE, MMMM d, y' }}</div>
    </ng-container> -->
    <div class="item-option d-none" [class.selected]="timeFilterValue == timeFilterValueEnum.ResultD6" (click)="timeFilterValueChange(timeFilterValueEnum.ResultD6, pageTypeEnum.Results)">
      {{D6 | date:'EE dd.MM.'}}
    </div>
    <div class="item-option d-none" [class.selected]="timeFilterValue == timeFilterValueEnum.ResultD5" (click)="timeFilterValueChange(timeFilterValueEnum.ResultD5, pageTypeEnum.Results)">
      {{D5 | date:'EE dd.MM.'}}
    </div>
    <div class="item-option d-none" [class.selected]="timeFilterValue == timeFilterValueEnum.ResultD4" (click)="timeFilterValueChange(timeFilterValueEnum.ResultD4, pageTypeEnum.Results)">
      {{D4 | date:'EE dd.MM.'}}
    </div>
    <div class="item-option d-none" [class.selected]="timeFilterValue == timeFilterValueEnum.ResultD3" (click)="timeFilterValueChange(timeFilterValueEnum.ResultD3, pageTypeEnum.Results)">
      {{D3 | date:'EE dd.MM.'}}
    </div>
    <div class="item-option" [class.selected]="timeFilterValue == timeFilterValueEnum.ResultD2" (click)="timeFilterValueChange(timeFilterValueEnum.ResultD2, pageTypeEnum.Results)">
      {{D2 | date:'EE dd.MM.'}}
    </div>
    <div class="item-option" [class.selected]="timeFilterValue == timeFilterValueEnum.ResultD1"
    (click)="timeFilterValueChange(timeFilterValueEnum.ResultD1, pageTypeEnum.Results)">
    {{D1 | date:'EE dd.MM.'}}
  </div>
  <div class="item-option" (click)="timeFilterValueChange(timeFilterValueEnum.ResultToday, pageTypeEnum.Results)"
    [class.selected]="timeFilterValue == timeFilterValueEnum.ResultToday"
    i18n="Sport tree radio date range Today@@SportTreeToday">Danas</div>
  </div>
  <!-- <section class="search">
    <app-search-events [isLive]="isLive"></app-search-events>
  </section> -->
</section>
